import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import BrandIntro from './components/BrandIntro';
import Testimonials from './components/Testimonials';
import ContactSection from './components/ContactSection';

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: '首页',
      item: 'https://alyonvc.cn/',
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: '关于我们',
      item: 'https://alyonvc.cn/about',
    },
  ],
};

const aboutPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'AboutPage',
  name: '关于女仆不只是工作',
  description: '女仆不只是工作是一个专注于女仆文化深度内容创作与传播的文化媒体平台，致力于探索女仆文化背后的情感连接、角色认同与生活方式。',
  url: 'https://alyonvc.cn/about',
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '女仆不只是工作编辑部',
  url: 'https://alyonvc.cn/',
  description: '专注于女仆文化深度内容创作与传播的文化媒体平台。',
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

export default function About() {
  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutPageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200/60">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-8">
            <Breadcrumb items={[{ label: '关于我们' }]} />
          </div>
        </div>

        <div className="py-10 md:py-16 px-4 md:px-6">
          <BrandIntro />
        </div>

        <div className="bg-background-100">
          <Testimonials />
        </div>

        <div className="px-4 md:px-6">
          <ContactSection />
        </div>
      </main>
      <Footer />
    </>
  );
}